<ion-header mode="md">
  <ion-toolbar class="ion-text-center">
    <ion-item lines="none">
      <ion-img
        class="logo"
        *ngIf="p.renderMobile"
        src="../assets/images/app-logo.svg"
      ></ion-img>
    </ion-item>
  </ion-toolbar>
</ion-header>
<ion-content scrollbar>
  <div
    *ngIf="!p.renderMobile"
    [ngClass]="{'cart__breadcrumb': cart.length === 0}"
  >
    <app-breadcrumb></app-breadcrumb>
  </div>
  <div class="cart__empty" *ngIf="cart.length === 0">
    <ion-text> {{ 'MARKET.BASKET_EMPTY' | translate }} </ion-text>
  </div>
  <ion-grid *ngIf="cart.length" class="no-padding-grid-box">
    <ion-row justify-content-center>
      <ion-col size="12" size-xl="9">
        <div class="cart__container">
          <ion-label
            [ngClass]="p.renderMobile ? 'cart__title--mobile' : 'cart__title'"
          >
            <ion-back-button
              *ngIf="p.renderMobile"
              defaultHref="app/market/provider/{{providerId}}"
            >
            </ion-back-button>
            <span> {{ 'MARKET.YOUR_PURCHASES' | translate }} </span>
          </ion-label>
          <div *ngFor="let item of cart">
            <div class="cart-element">
              <ion-grid class="ion-no-padding">
                <ion-row>
                  <ion-col size="4" class="display-flex">
                    <ion-img
                      class="cart-element__product-image"
                      [src]="item.image ? item.image.filePath : '../assets/icons/service-plug.svg'"
                    >
                    </ion-img>
                  </ion-col>
                  <ion-col size="8" class="display-flex">
                    <ion-item lines="none" class="display-flex">
                      <ion-label class="cart-element__name">
                        {{item.name}}
                      </ion-label>
                    </ion-item>
                  </ion-col>
                </ion-row>
              </ion-grid>
              <ion-grid class="no-margin cart-element__bottom-grid">
                <ion-row class="cart-element__bottom-row">
                  <ion-col size="5">
                    <table class="cart-element__increase-decrease">
                      <tr>
                        <td (click)="decreaseCartItem(item)">
                          <ion-icon
                            name="remove-outline"
                            slot="icon-only"
                          ></ion-icon>
                        </td>
                        <td class="cart-element__number-td">{{item.amount}}</td>
                        <td (click)="increaseCartItem(item)">
                          <ion-icon
                            name="add-outline"
                            slot="icon-only"
                          ></ion-icon>
                        </td>
                      </tr>
                    </table>
                  </ion-col>
                  <ion-col class="cart-element__costs-col" size="5">
                    <div class="cart-element__costs">
                      <div>
                        <p class="cart-element__total-cost">
                          {{ item.amount * item.price | currency:' '}} {{'PLN'|
                          translate}}
                        </p>
                      </div>
                      <div *ngIf="item.amount > 1">
                        <p class="cart-element__single-cost">
                          {{item.price | currency:' '}} {{'PLN'| translate}} {{
                          "MARKET.FOR_EACH" | translate }}
                        </p>
                      </div>
                    </div>
                  </ion-col>
                  <ion-col size="2">
                    <ion-button
                      size="small"
                      class="margin-top-10"
                      fill="clear"
                      color="medium"
                      (click)="removeCartItem(item)"
                    >
                      <ion-icon
                        name="trash-outline"
                        slot="icon-only"
                      ></ion-icon>
                    </ion-button>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
          </div>
          <div
            [ngClass]="{'w-50': !p.renderMobile}"
            class="cart__order-description"
          >
            <ion-label> {{'MARKET.ORDER_DESCRIPTION' | translate }} </ion-label>
            <ion-textarea
              rows="2"
              autoGrow="true"
              [(ngModel)]="description"
            ></ion-textarea>
          </div>
          <ion-col> </ion-col>
        </div>
      </ion-col>
      <ion-col size="12" size-xl="3">
        <ion-grid class="box cart__container">
          <ion-row class="small-padding" justify-content-center>
            <ion-col
              class="full-width"
              [ngClass]="p.renderMobile ? 'cart__total--mobile' : 'cart__total'"
            >
              <ion-label>
                <h1>{{'MARKET.TO_PAY' | translate}}</h1>
              </ion-label>

              <ion-grid class="ion-no-padding w-100">
                <ion-row>
                  <ion-col>
                    <ion-label>
                      {{ 'MARKET.TOTAL_COST' | translate}}:
                    </ion-label>
                  </ion-col>
                  <ion-col>
                    <ion-label>
                      {{ getTotal() | currency:' '}} {{'PLN'| translate}}
                    </ion-label>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="12" class="display-flex">
                    <ion-button
                      [disabled]=" (cart.length == 0) || checkoutButtonDisable"
                      size="large"
                      class="cart__checkout-button"
                      (click)="checkout()"
                    >
                      {{'MARKET.CHECKOUT' | translate}}
                    </ion-button>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div>
    <ion-button
      [ngClass]="p.renderMobile ? 'margin-top-25px' : 'margin-top-30px'"
      class="cart__back-to-shopping"
      fill="clear"
      (click)="close()"
    >
      <ion-icon name="chevron-back-outline" slot="icon-only"></ion-icon>
      <ion-label> {{ 'MARKET.RETURN_TO_SHOPPING' | translate }} </ion-label>
    </ion-button>
  </div>
</ion-content>
